import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import { Toaster } from 'sonner';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CallsListPage from './pages/CallsListPage';
import ProcessedCallsPage from './pages/ProcessedCallsPage';
import CallDetailPage from './pages/CallDetailPage';
import AgentAnalyticsPage from './pages/AgentAnalyticsPage';
import UserManagementPage from './pages/UserManagementPage';
import ReportsPage from './pages/ReportsPage';
import ProcessingMonitorPage from './pages/ProcessingMonitorPage';
import SettingsPage from './pages/SettingsPage';
import FetchLogsPage from './pages/FetchLogsPage';
import TagsPage from './pages/TagsPage';
import TagsDashboardPage from './pages/TagsDashboardPage';
import AutoProcessingTabs from './pages/AutoProcessingTabs';
import AgentCoachingPage from './pages/AgentCoachingPage';
import Contact from './pages/contact';
import './App.css';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}

// Coaching is for the agent and supervisor logins. Any other role that reaches
// the URL directly is sent back to the dashboard; the API enforces the same rule
// and additionally scopes a supervisor to the agents assigned to them.
function CoachingRoute({ children }) {
  const { isAgent, isSupervisor } = useAuth();
  if (!isAgent && !isSupervisor) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { isAuthenticated } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="calls" element={<CallsListPage />} />
        <Route path="processed" element={<ProcessedCallsPage />} />
        <Route path="calls/:callId" element={<CallDetailPage />} />
        <Route path="agents" element={<AgentAnalyticsPage />} />
        <Route path="my-coaching" element={<CoachingRoute><AgentCoachingPage /></CoachingRoute>} />
        <Route path="users" element={<UserManagementPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="processing" element={<ProcessingMonitorPage />} />
        <Route path="gemini-processing" element={<AutoProcessingTabs />} />
        <Route path="tags" element={<TagsPage />} />
        <Route path="tags-dashboard" element={<TagsDashboardPage />} />
        <Route path="fetch-logs" element={<FetchLogsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="records" element={<Contact />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="min-h-screen bg-background app-noise">
          <AppRoutes />
          <Toaster richColors position="top-right" />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}
